import { useEffect, useState, useMemo } from 'react'
import { observer, Observer } from 'mobx-react-lite'
import { Typography } from 'ui-components-web'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { getDate } from 'date-fns/getDate'
import { getMonth } from 'date-fns/getMonth'
import User from 'singletons/User'
import Modals from 'singletons/Modals'
import Calendar from 'components/UI/Calendar'
import MobileCalendar from 'components/UI/MobileCalendar'
import { formatDate } from 'util/formatters'
import MonthSlider from './components/MonthSlider'
import Actions from './components/Actions'
import VisitsList from './VisitsList'
import withResolution from 'hoc/withResolution'
import { getWeekDays } from 'util/formatters'

import useStyles from './styles'
import { Navigate } from 'react-router'
import { DASHBOARD, DASHBOARD_SCHEDULE } from 'constants/routing'

const Schedule = ({ isMobile }) => {
  const classes = useStyles()
  const [date, setDate] = useState(() => new Date())
  const curMonth = getMonth(date)

  const weekDays = useMemo(() => getWeekDays(), [])
  let weekNumber = 0

  const renderCell = (d, i) =>
    curMonth === getMonth(d) ? (
      <Observer key={i}>
        {() => {
          const dateString = formatDate(d)
          const visitsList = User.provider?.visitQueue.byScheduledDate?.[dateString]
          const len = visitsList?.length || 0
          // const blackouts = User.provider?.blackoutDatesList.forDate(d);
          weekNumber = i !== 0 && i % 7 === 0 ? weekNumber + 7 : weekNumber
          const openAll = (e) => {
            e.stopPropagation()
            len && Modals.open('dayVisits', { dateString })
          }
          const openBrief = (e, visit) => {
            e.stopPropagation()
            Modals.open('briefScheduling', {
              visit,
            })
          }
          return (
            <div
              className={classNames(
                classes.cell,
                len ? classes.cursorPointer : false,
                // blackouts.length ? classes.greyBackground : false,
              )}
              onClick={openAll}
            >
              <div className={classes.cellDateRow}>
                {isMobile && (
                  <Typography key={d} variant={'body2'} className={classes.weekDay}>
                    {i >= 7 ? weekDays[i - weekNumber] : weekDays[i]}
                  </Typography>
                )}
                <Typography className={classes.cellDateLabel}>{getDate(d)}</Typography>
                {/* blackouts.length ? (
                  <div
                    className={classes.scheduleIconContainer}
                    title={`Unavailable:\n${blackouts
                      .map((p) => p.formattedPair.join(' - '))
                      .join('\n')}`}
                  >
                    <ScheduleCanceled />
                  </div>
                ) : null */}
              </div>
              {len ? (
                <VisitsList
                  visits={visitsList}
                  onRowClick={openBrief}
                  onSummaryRowClick={openAll}
                  isMobile={isMobile}
                />
              ) : isMobile ? (
                <div className={classes.emptyCell} />
              ) : null}
            </div>
          )
        }}
      </Observer>
    ) : (
      <div key={i} />
    )

  useEffect(() => {
    User.provider?.visitQueue.refetchMonth(date)
  }, [date])

  const { showV1Schedule, showV3Schedule } = User?.provider?.scheduleVersionConfig || {}

  if (!showV1Schedule) {
    return <Navigate to={showV3Schedule ? DASHBOARD_SCHEDULE : DASHBOARD} replace />
  }

  return (
    <div className={classes.scheduleContainer}>
      <div className={classes.scheduleHeader}>
        <MonthSlider date={date} setDate={setDate} />
        <Actions />
      </div>
      {isMobile ? (
        <MobileCalendar date={date} classes={{ cells: classes.cells }} renderCell={renderCell} />
      ) : (
        <Calendar date={date} classes={{ cells: classes.cells }} renderCell={renderCell} />
      )}
    </div>
  )
}
export default withResolution(1100)(observer(Schedule))
